<template lang="pug">
.t-and-c
    .t-and-c-header.side-padding-32
        p {{ getString('screen.t_and_c.title', 'Please read and accept these terms and conditions.') }}
    .t-and-c-content.side-padding-32(v-html="$filters.sanitize(tAndC)")
    .t-and-c-actions.side-padding-32
        template(v-if="tAndCAccepted")
            aiq-button.t-and-c-back(@click="back" type="primary") {{ getString('screen.t_and_c.back', 'Back') }}
        template(v-else)
            aiq-button.t-and-c-accept(type="primary" @click="accept") {{ getString('screen.t_and_c.accept', 'Accept') }}
            aiq-button.t-and-c-decline(type="primary" plain @click="decline") {{ getString('screen.t_and_c.decline', 'decline') }}
    aiq-dialog(:title="getString('screen.t_and_c.decline_dialog_title', 'Terms & Conditions')",
                :model-value="tAndCDeclinedVisible"
                :modal="true"
                :show-close="false")
     template(v-slot:header)
      .decline-title
        span {{ getString('screen.t_and_c.decline_dialog_title', 'Terms & Conditions') }}
        .interactive-icon.active(tabindex="0"
                                @click="closeDialog"
                                @keydown.enter.stop=""
                                @keyup.enter="closeDialog"
                                role="button"
                                :aria-label="getString('screen.chat.decline_dismiss', 'Dismiss decline dialog')")
          fa-icon(:icon="['fas', 'x']")
     p(tabindex="0") {{ getString('screen.t_and_c.decline_message', 'Sorry, without agreeing with the Terms and Conditions, you\'re not able to proceed.') }}
</template>

<script>
import i18n from '../../mixins/i18n';

export default {
  name: 't-and-c-component',
  mixins: [i18n],
  props: {
    tAndCData: {
      type: Object,
      default: () => ({ content: '{}' }),
    },
    tAndCAccepted: Boolean,
    tAndCDeclined: Boolean,
  },

  data() {
    const { tAndC, tAndC_langkey } = JSON.parse(this.$props.tAndCData.content);
    return {
      tAndC: this.getString(tAndC_langkey, { ns: 'configurable', defaultValue: tAndC }),
      tAndCDeclinedVisible: this.tAndCDeclined,
    };
  },

  methods: {
    accept() {
      this.$emit('accept');
    },

    decline() {
      this.tAndCDeclinedVisible = true;
      this.$emit('decline');
    },

    back() {
      this.$emit('back');
    },

    closeDialog() {
      this.tAndCDeclinedVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "../../aiq-theme/aiq-variables";
.t-and-c {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 0px 15px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .el-dialog {
      width: 80%;
    }

    .decline-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
}

.side-padding-32 {
  padding: 0 32px;
}

.t-and-c-content {
    flex-grow: 1;
    overflow-y: scroll;
    color: $aiq-webchat-darker-text;
}

.t-and-c-actions {
    margin-top: 16px;
    display: block;
    justify-content: center;
    flex-direction: column;

    .t-and-c-accept,
    .t-and-c-back {
        color: #FFF;
        background: #198cfd;
        height: 48px;
        font-size: 20px;
        width: 100%;
        font-weight: 500;

        &:hover {
          color: #FFF;
        }
    }

    .t-and-c-decline {
        height: 48px;
        color: #198cfd;
        width: 100%;
        background: transparent;
        border: 1px solid #198cfd;
        font-size: 20px;
        font-weight: 500;
    }

    .t-and-c-decline.el-button {
      margin-left: 0px;
    }

}

@media (max-width: 767px),
       only screen and (min-device-width : 768px) and (max-device-width : 1024px),
       only screen  and (device-width: 414px) and (device-height: 896px)  and (-webkit-device-pixel-ratio: 2),
       only screen  and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
       only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)
 {
  .t-and-c-header {
      padding-top: 24px;
      padding-bottom: 8px;

      h3 {
          font-weight: 500;
          padding-bottom: 10px;
      }
      p {
        font-weight: 300;
      }
  }
}

.t-and-c-header {
    text-align: center;
    padding-top: 24px;
    padding-bottom: 8px;
    color: $aiq-webchat-ligher-text;

    h3 {
        font-weight: 500;
        padding-bottom: 10px;
    }
    p {
      font-weight: 300;
    }

}
</style>
